import { Component, OnInit, OnDestroy, OnChanges, ViewChild, Input, SimpleChange, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { Pregunta } from '../_models/pregunta.model';
import { Respuesta } from '../_models/respuesta.model';
import { Solucion } from '../_models/solucion.model';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";
import { CuestionarioService } from "../_services/cuestionario.service";

import { AppSettings } from '../_models/settings.models'

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';
import { DragulaService } from 'ng2-dragula';

declare var jQuery:any;

@Component({
  selector: 'pregunta',
  templateUrl: 'pregunta.template.html',
  //providers:  [PreguntasService]
})
export class PreguntaComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() _pregunta: any;
  @Input() _contador: string;
  @Input() _id_cuestionario: number;
  @Input() _test: boolean;

  @ViewChild('preguntatext') preguntatext;

  @Output() onBorrarPregunta = new EventEmitter<number>();

  subscription: Subscription;

  pregunta: Pregunta = new Pregunta();
  id_cuestionario: number = 0;
  test: boolean;
  contador: string;

  listarespuestas: Array<Respuesta> = [];

  mostrarmodal: boolean= false;

  editando: boolean = false;
  desplegado: boolean = true;

  apiurl: string = AppSettings.API_URL;
 
  subs = new Subscription();

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private globalEventsManager: GlobalEventsManager,
              private cuestionarioService: CuestionarioService,
              private confirmationService: ConfirmationService,
              private activatedRoute: ActivatedRoute,
              private dragulaService: DragulaService){
        
                
            

   /*           this.subs.add(this.dragulaService.drag("bag1")
                .subscribe(({ name, el, source }) => {
                  console.log('drag');
                  console.log(name);
              //    console.log(el);
                  console.log(source);
                })
              );              
              this.subs.add(this.dragulaService.drop("bag1")
              .subscribe(({ name, el, target, source, sibling }) => {
            //    console.log('drop');
              })
            );
*/
    /*        this.subs.add(this.dragulaService.drag("bag2")
            .subscribe(({ name, el, source }) => {
              console.log('drag');
              console.log(name);
              console.log(el);
          //    console.log(source);
            })
          );   
          */           
  }
 
  ngOnInit(){



  }

 

  ngOnDestroy(){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_pregunta']){
      this.pregunta = changes['_pregunta'].currentValue;
      this.listarespuestas = this.pregunta.respuestas;
      this.editando = this.pregunta.editar;
    }

    if (changes['_id_cuestionario']){
      this.id_cuestionario = changes['_id_cuestionario'].currentValue;
      this.pregunta.id_cuestionario = this.id_cuestionario;
    }

    if (changes['_test']){
      this.test = changes['_test'].currentValue;
      if (this.test){
        this.desplegado = false;
      }
    }

    if (changes['_contador']){
      this.contador = changes['_contador'].currentValue;
    }

  }

  
  anadirRespuesta(){

    let encontrado: boolean = false;

    for (let respuesta of this.listarespuestas){

      if (respuesta.id_respuesta == 0){
        encontrado = true;
      }

    }

    if (!encontrado){

      let nuevarespuesta = new Respuesta();
      nuevarespuesta.respuesta = "Respuesta nueva";
      nuevarespuesta.editar = true;
      nuevarespuesta.id_pregunta = this.pregunta.id_pregunta;

      this.listarespuestas.push(nuevarespuesta);

    }

  }

  onBorrarRespuesta(event){

    //elimino la respuesta
    let respuesta: any;

    respuesta = {
      id_respuesta : event,
      id_cuestionario: this.pregunta.id_cuestionario
    };

    this.cuestionarioService.deleteRespuesta(respuesta).subscribe(
      data => {
        if (data){

          let encontrado : number;

          for (let i = 0; i < this.listarespuestas.length; i++){
            if (this.listarespuestas[i].id_respuesta == event){
              encontrado = i;
            }
          }

          this.listarespuestas.splice(encontrado,1);

          this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);
          this.globalEventsManager.getEvidenciasSinRelacionarCuestionario(this.id_cuestionario);

        }
      }
    );

  }

  editar(){
    if (!this.test){
      this.editando = true;
      setTimeout(() => this.focus(), 50);
    }
  }

  focus(){
    jQuery("#input_pregunta_"+this.pregunta.id_pregunta).focus();
  }

  guardar(){

    if (this.editando){

      this.editando = false;
      console.log(this.pregunta);

      let pregunta: any;

      pregunta = {
        id_respuesta : this.pregunta.id_respuesta,
        pregunta: this.pregunta.pregunta,
        id_tipo: 1,
        id_pregunta: this.pregunta.id_pregunta,
        id_cuestionario: this.pregunta.id_cuestionario
      };

      this.cuestionarioService.setPregunta(pregunta).subscribe(
        data => {
          if (data){
            console.log(data.json());

            let al: any = {
              "texto" : "Cuestionario guardado",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            this.pregunta.id_pregunta = data.json().cuestionario.id_pregunta;

          }
        }
      );

    }

  }

  ver(id: string){
    this.desplegado = true;
    jQuery("#pregunta_"+id).slideDown('fast');
    
  }

  ocultar(id: string){
    this.desplegado = false;
    jQuery("#pregunta_"+id).slideUp('fast');
  }

  borrar(){
    this.onBorrarPregunta.emit(this.pregunta.id_pregunta);
  }

  confirmBorrar() {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la pregunta?',
          accept: () => {
              this.borrar();
          }
      });
  }

  abrirModal(){
    this.mostrarmodal = true;
  }

  onChangeModal(event){
    this.mostrarmodal = false;
    let url = event;
    this.pregunta.urldocumento = url;
  }

  borrarDocumento(){

    this.cuestionarioService.deleteDocumento(this.pregunta.id_pregunta, this.pregunta.id_cuestionario).subscribe(
      data => {
        if (data){

          this.pregunta.urldocumento = "";

        }
      }
    );


  }

  confirmBorrarDocumento() {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el documento?',
          accept: () => {
              this.borrarDocumento();
          }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/cuestionario/pregunta.component.ts